import { BaseComment } from '../base/base-comment';

export class ScheduledRemittanceComment extends BaseComment {
  public remittanceId!: number;
}
